jQuery(($) => {
    function notYetImplemented(e) {
        e.preventDefault();
        alert('this function is not yet implemented');
    }

    function toggleReply(e) {
        e.preventDefault();
        var $comment = $(this).closest('.c-comment');
        $comment.find('.c-comment-form-container').slideToggle();
    }

    $('.js-comment-like-btn').on('click', notYetImplemented);
    $('.js-comment-link-btn').on('click', notYetImplemented);
    $('body').on('click', '.js-comment-reply-btn', toggleReply);
    $('body').on('click', '.c-comment .c-cancel-button', toggleReply);
});
